import React, { useState } from "react";
import Comment from "./Comment";
import ReviewsFilters from "./ReviewsFilters";

const Reviews = ({ data, doctors, totalPages }) => {
  const [page, setPage] = useState(1);
  const [reviews, setReviews] = useState(data);
  const [doctor, setDoctor] = useState('');
  const [pages, setPages] = useState(totalPages);
  const doctors_ordered = new Map(doctors);

  const url = '/reviews'
  const axios = require('axios');
  axios.defaults.headers.common['Accept'] = 'application/json'

  const handleSubmit = e => {
    e.preventDefault();

    axios.get(url, {
      params: { page: page + 1, doctor: doctor }
    }, {headers: {'Content-Type': 'text/javascript'}})
    .then(function (response) {
      setReviews([...reviews, ...response.data.reviews]);
      setPage(page + 1);
    })
    .catch(function (error) {
      console.log(error);
    });
  };

  const handleFilter = currentIndex => {
    axios.get(url, {
        params: { doctor: currentIndex }
    })
    .then(function (response) {
      setReviews(response.data.reviews);
      setDoctor(currentIndex);
      setPage(1);
      setPages(response.data.pages)
    })
    .catch(function (error) {
      console.log(error);
    });
  }

  return (
    <div>
      <ReviewsFilters handleFilter={handleFilter} doctors={doctors_ordered} />
      {reviews.map((element, index) => (
        <Comment
          key={index}
          date={element.date}
          name={element.name}
          doctor={element.doctor}
          text={element.text}
        />
      ))}
      {page < pages &&
        <span className="reviews-button-animation-container animation-waypoint animation-trigger">
          <a className="button button_large reviews__button" onClick={handleSubmit} rel="next">Еще 20 отзывов</a>
        </span>
      }
      {reviews.length == 0 &&
        <div className='reviews-page__no-results'>Нет результатов</div>
      }
    </div>
  )
};

export default Reviews;
